import * as React from "react"
export const HomeIcon = (props) => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M9.99998 1.5L0 10.5H3V18.5H8.00001V12.5H12V18.5H17V10.5H20L9.99998 1.5Z'
      fillRule='evenodd'
      clipRule='evenodd'
      stroke='currentColor'
      fill='currentColor'
    />
  </svg>
)
